import { isSessionRound, isSessionSpeeddate, isTask } from 'common-data-handling';
import { sortBy } from 'lodash';
import React from 'react';
import { useI18n } from '../../../../../data/hooks/i18nHooks';
import { useRounds } from '../../useRounds';
import MeetingInProgram from '../MeetingInProgram';
import ProgramGroup from '../ProgramGroup/ProgramGroup';
import ProgramItem from '../ProgramItem';
import Task from '../Task';
import Icon from '../../../../elements/icons/Icon';

function GroupedProgramItems(props) {
    const { event, items, focusedRoundId , expandRounds} = props,
        i18n = useI18n(),
        rounds = useRounds(event.id, items),
        sortedItems = sortBy(items, 'start');

    return sortedItems.map((item) => {
        if (item._isMeeting) {
            return <MeetingInProgram item={item} event={event} i18n={i18n} key={`meeting-${item.id}`} />;
        } else if (isTask(item)) {
            return <Task task={item} event={event} key={`task-${item.id}`} />;
        } else if (isSessionRound(item)) {
            if (rounds[item.id].unfiltered.length) {
                return (
                    <ProgramGroup
                        event={event}
                        round={item}
                        expanded={expandRounds ? true : focusedRoundId ? item.id === focusedRoundId : undefined}
                        items={rounds[item.id].visible}
                        unfilteredGroup={rounds[item.id].unfiltered}
                        key={item.id}
                        i18n={i18n}
                        scrollIntoView={focusedRoundId === item.id}
                    />
                );
            } else {
                return null;
            }
        } else if (!item.round_id) {
            return <ProgramItem item={item} event={event} i18n={i18n} key={item.id} />;
        } else {
            return null;
        }
    });
}

export default GroupedProgramItems;
